module.exports = __webpack_public_path__ + "static/media/05.c571d0b9.jpg";